module.exports = __webpack_public_path__ + "static/img/23-3.5a8ce74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/23-3.jpg
// module id = cEOJ
// module chunks = 0